export const MAP_POINTS = [
  { lat: 31.2304, lng: 121.4737 },
  { lat: 22.5431, lng: 114.0579 },
  { lat: 23.1291, lng: 113.2644 },
  { lat: 39.9042, lng: 116.4074 },
  { lat: 31.2983, lng: 120.5832 },
  { lat: 37.4563, lng: 126.7052 },
  { lat: 35.1796, lng: 129.0756 },
  { lat: 35.4437, lng: 139.638 },
  { lat: 35.1815, lng: 136.9066 },
  { lat: 25.033, lng: 121.5654 },
  { lat: 10.8231, lng: 106.6297 },
  { lat: 21.0285, lng: 105.8542 },
  { lat: 13.7563, lng: 100.5018 },
  { lat: 14.5995, lng: 120.9842 },
  { lat: -6.2088, lng: 106.8456 },
  { lat: 3.139, lng: 101.6869 },
  { lat: 16.8409, lng: 96.1735 },
  { lat: 11.5564, lng: 104.9282 },
  { lat: 1.3521, lng: 103.8198 },
  { lat: 19.076, lng: 72.8777 },
  { lat: 28.7041, lng: 77.1025 },
  { lat: 12.9716, lng: 77.5946 },
  { lat: 13.0827, lng: 80.2707 },
  { lat: 17.385, lng: 78.4867 },
  { lat: 24.8607, lng: 67.0011 },
  { lat: 31.5497, lng: 74.3436 },
  { lat: 23.8103, lng: 90.4125 },
  { lat: 6.9271, lng: 79.8612 },
  { lat: 22.5176, lng: 113.3928 },
  { lat: 23.0205, lng: 113.7518 },
  { lat: 23.0215, lng: 113.1214 },
  { lat: 23.11, lng: 114.416 },
  { lat: 29.079, lng: 119.6474 },
  { lat: 30.2741, lng: 120.1551 },
  { lat: 27.9949, lng: 120.6994 },
  { lat: 29.8683, lng: 121.544 },
  { lat: 31.4909, lng: 120.3124 },
  { lat: 32.0101, lng: 119.6065 },
  { lat: 36.0671, lng: 120.3826 },
  { lat: 37.4638, lng: 121.448 },
  { lat: 35.405, lng: 116.5871 },
  { lat: 41.8057, lng: 123.4315 },
  { lat: 41.7283, lng: 125.9397 },
  { lat: 31.8206, lng: 117.2272 },
  { lat: 23.0225, lng: 72.5714 },
  { lat: 26.4499, lng: 80.3319 },
  { lat: 30.9, lng: 75.8573 },
  { lat: 22.5726, lng: 88.3639 },
  { lat: 28.4089, lng: 77.3178 },
  { lat: 26.9124, lng: 75.7873 },
  { lat: 11.0168, lng: 76.9558 },
  { lat: 21.1702, lng: 72.8311 },
  { lat: 22.7196, lng: 75.8577 },
  { lat: 18.5204, lng: 73.8567 },
  { lat: 28.5355, lng: 77.391 },
  { lat: 28.6139, lng: 77.209 },
  { lat: 11.1085, lng: 77.3411 },
  { lat: 22.3039, lng: 70.8022 },
  { lat: 27.1767, lng: 78.0081 },
  { lat: 17.6868, lng: 83.2185 },
  { lat: 25.5941, lng: 85.1376 },
  { lat: 22.5843, lng: 113.0819 },
  { lat: 29.318, lng: 120.1375 },
  { lat: 28.6564, lng: 121.4208 },
  { lat: 31.8107, lng: 119.9737 },
  { lat: 32.0603, lng: 118.7969 },
  { lat: 24.9017, lng: 118.5858 },
  { lat: 24.4798, lng: 118.0895 },
  { lat: 38.0428, lng: 114.5149 },
  { lat: 30.5728, lng: 104.0668 },
  { lat: 18.7883, lng: 98.9853 },
  { lat: 13.3611, lng: 100.9847 },
  { lat: -7.2575, lng: 112.7521 },
  { lat: -6.9667, lng: 110.4167 },
  { lat: 10.3157, lng: 123.8854 },
  { lat: 7.1907, lng: 125.4553 },
  { lat: 41.0082, lng: 28.9784 },
  { lat: 40.1828, lng: 29.0664 },
  { lat: 38.4237, lng: 27.1428 },
  { lat: 41.1579, lng: -8.6291 },
  { lat: 38.7223, lng: -9.1393 },
  { lat: 41.5454, lng: -8.4265 },
  { lat: 19.4326, lng: -99.1332 },
  { lat: 20.6597, lng: -103.3496 },
  { lat: 25.6866, lng: -100.3161 },
  { lat: 32.5149, lng: -117.0382 },
  { lat: 21.1221, lng: -101.682 },
  { lat: 19.0414, lng: -98.2063 },
  { lat: 20.5888, lng: -100.3899 },
  { lat: 22.1565, lng: -100.9855 },
  { lat: 21.8823, lng: -102.2826 },
  { lat: 19.2826, lng: -99.6557 },
  { lat: 31.6904, lng: -106.4245 },
  { lat: 29.0729, lng: -110.9559 },
  { lat: 42.3314, lng: -83.0458 },
  { lat: 34.052235, lng: -118.243683 },
  { lat: 32.7767, lng: -96.797 },
  { lat: 37.7749, lng: -122.4194 },
  { lat: 44.9778, lng: -93.265 },
  { lat: 40.4406, lng: -79.9959 },
  { lat: 39.7684, lng: -86.1581 },
  { lat: -12.0464, lng: -77.0428 },
  { lat: -34.6037, lng: -58.3816 },
  { lat: -31.4201, lng: -64.1888 }
];
